// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"1529f865","308":"e77f3c48"}[chunkId] + ".chunk.js";
};